module.exports = __webpack_public_path__ + "img/rewards-navy.c1f75b8d.svg";